import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import styles from './ActiveServicesCard.module.css'

interface ActiveServicesCardProps {
    score: number | undefined;
    maxScore: number | undefined;
    status: string | undefined;
}

export function ActiveServicesCard({ score = 0, maxScore = 0, status }: ActiveServicesCardProps) {

    const setMessage = () => {

        if (status === 'ALTA') {
            return (
                <div className='margin-top-20'>
                    Excelente! Você aproveita o <span className='text-bold'>máximo</span> do nosso ecossistema de serviços.
                </div>
            )
        } else if (status === 'INTERMEDIARIA' || status === 'BAIXA') {
            return (
                <div className='margin-top-20'>
                    <span className='text-bold'>Diversifique seus serviços</span> contratados para aumentar sua pontuação.
                </div>
            )
        } else {

        }
    }

    return (
        <StatsWidgets>
            <StatsWidget className='shadow-default' style={{ height: 250 }}>
                <StatsWidget.Header>Serviços Ativos</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className='text-center'>
                            <div>
                                {score === maxScore ? (
                                    <div style={{ fontSize: 40 }}>
                                        <span className={styles["current-score"]}>{score}</span>
                                    </div>
                                ) : (
                                    <div style={{ fontSize: 40 }}>
                                        <span className={styles["current-score"]}>{score}</span>
                                        <span className={styles["total-score"]}>/ {maxScore}</span>
                                    </div>
                                )}
                                {score === maxScore ? (
                                    <div className='margin-top-10'>
                                        <div className="label text-size-12 label-success">
                                            Pontuação Máxima! <span className='rioglyph rioglyph-trophy'></span>
                                        </div>
                                    </div>
                                ) : (
                                   null
                                )}
                            </div>
                        </div>
                        <div>
                            {setMessage()}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}